export const name = "ATANH";
export const summary = `Computes the inverse hyperbolic tangent of \`X\`.`;
export const reference = `
## ATANH

Computes the inverse hyperbolic tangent of \`X\`.

\`\`\`
ATANH(X)
\`\`\`

### Description

Computes the inverse hyperbolic tangent of X. Generates an error if X is outside of the range (-1, 1).

| X | ATANH(X) |
| --- | --- |
| \`+inf\` | \`NaN\` |
| \`-inf\` | \`NaN\` |
| \`NaN\` | \`NaN\` |
| X \\< -1 | Error |
| X \\> 1 | Error |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
